module.exports = __webpack_public_path__ + "img/Jump Casting101.bd7dd616.jpg";